import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const deleteProfile = async (email) => {
    return axios.delete(`${BACKEND_URL}/profiles/${email}`);
};

export const deleteProfilePicture = async (email) => {
    return axios.delete(`${BACKEND_URL}/profiles/${email}/picture`);
};

export const getProfile = async (email) => {
    return axios.get(`${BACKEND_URL}/profiles/${email}`);
};

export const getProfilePicture = async (email) => {
    return axios.get(`${BACKEND_URL}/profiles/${email}/picture`, { responseType: 'blob' });
};

export const getProfileType = async (email) => {
    return axios.get(`${BACKEND_URL}/profiles/${email}/type`);
};

export const updateProfile = async (email, profile) => {
    return axios.put(`${BACKEND_URL}/profiles/${email}`, profile);
};

export const updateProfilePicture = async (email, file, setLoaded) => {
    return axios.put(`${BACKEND_URL}/profiles/${email}/picture`, file, {
        onUploadProgress: progressEvent => {
            setLoaded(progressEvent.loaded / progressEvent.total * 100)
        }
    });
};